export default "__VITE_ASSET__Hev_dvcF__"